export function onTab(node: HTMLElement, { keys = [], callbackFunction }: { keys: string[], callbackFunction: CallbackFn }) {

  function handleKeyDown(event: KeyboardEvent) {
    if (keys.length === 0 || keys.includes(event.key)) {
      callbackFunction(event.key, event.target);
    }
  }

  node.addEventListener("keydown", handleKeyDown);

  return {
    update(newParams: any) {
      callbackFunction = newParams.callbackFunction;
      keys = newParams.keys;
    },
    destroy() {
      node.removeEventListener("keydown", handleKeyDown);
    },
  };
}